<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form
            :model="model"
            :weerstations="weerstations"
            :voorspellingsplaatsen="voorspellingsplaatsen"
            :isEditing="true"
            @save-item="updateItem">
        </item-form>

        <b-modal title="Wijzigen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Bedrijf werd niet gewijzigd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/bedrijf';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                weerstations: [],
                voorspellingsplaatsen: [],
                model: {
                },
            };
        },
        created () {
            api.getDetailBedrijf(this.$route.params.id).then((response) => {
                this.weerstations = response.data.weerstations;
                this.voorspellingsplaatsen = response.data.voorspellingsplaatsen;
                this.model = response.data.model;
            });
        },
        methods: {
            updateItem (model) {
                api.updateBedrijf(model).then(() => {
                    this.$router.replace('/beheer/bedrijf');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/bedrijf/Edit.vue